// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3xBEs","signatureBlock":"Footer_signatureBlock__11YKi","signature":"Footer_signature__2Kr2P"};